import { getRecoil, setRecoil } from "recoil-nexus";
import roomDetailState from "../../atoms/roomDetail";
import { socket } from "../index";
import { UserDetail } from "../type";

interface ListenReceiveRoomDetailPayload {
  id: string;
  owner: string;
  participants: number;
  uniqueParticipants: number;
  name: string;
  description: string;
  maxParticipants: number;
  isPremium: boolean;
  isSecret: boolean;
  ownerDetail: UserDetail;
}

const listenReceiveRoomDetail = () => {
  socket?.on('RECEIVE_ROOM_DETAIL', (payload: { roomDetail: ListenReceiveRoomDetailPayload }) => {
    const roomDetail = getRecoil(roomDetailState);

    setRecoil(roomDetailState, {
      ...roomDetail,
      ...payload.roomDetail,
    });
  });
}

export default listenReceiveRoomDetail;